import React from 'react';
import { useNavigate } from 'react-router-dom';
import { useMediaQuery } from '../../../common/hooks/useMediaQuery';
import nextGearCarIcon from '../../../assets/img/nextGear/next-gear-icon.png';
import nextGearWhyUseCarDesktop from '../../../assets/img/nextGear/next-gear-why-use-desktop.png';
import nextGearWhyUseCarMobile from '../../../assets/img/nextGear/next-gear-why-use-mobile.png';
import poundsIcon from '../../../assets/img/nextGear/next-gear-pound-icon.svg';
import handshakeIcon from '../../../assets/img/nextGear/next-gear-handshake-icon.svg';
import receiptIcon from '../../../assets/img/nextGear/next-gear-receipt-icon.svg';
import devicesIcon from '../../../assets/img/nextGear/next-gear-devices-icon.svg';

function NextGearWhyUse() {
  const navigate = useNavigate();
  const isMobile = useMediaQuery('(max-width: 768px)');

  const listItems = [
    {
      id: 'item-1',
      icon: poundsIcon,
      title: 'Improved cash flow',
      text: 'Free up working capital',
    },
    {
      id: 'item-2',
      icon: handshakeIcon,
      title: 'More buying power',
      text: 'Bid for more stock',
    },
    {
      id: 'item-3',
      icon: receiptIcon,
      title: 'Flexibility',
      text: 'Up to 150 days repayment',
    },
    {
      id: 'item-4',
      icon: devicesIcon,
      title: 'Seamless process',
      text: 'Built into checkout',
    },
  ];

  const sectionImage = isMobile ? nextGearWhyUseCarMobile : nextGearWhyUseCarDesktop;

  return (
    <section className="ng-why-use">
      <div className="ng-why-use__inner">
        <img src={sectionImage} alt="NextGear Why Use" className="ng-why-use__car" />
        <div className="ng-why-use__content">
          <h2 className="ng-why-use__title">Why use NextGear Capital funding?</h2>
          <ul className="ng-why-use__list">
            {listItems.map(({ id, title, text, icon }) => (
              <li key={id} className="ng-why-use__list-item">
                <div className="ng-why-use__list-item-box">
                  <img src={icon} alt="NextGear Icon" className="ng-why-use__list-item-icon" />
                </div>
                <div className="ng-why-use__list-item-content">
                  <span className="ng-why-use__list-item-title">{title}</span>
                  <span className="ng-why-use__list-item-text">{text}</span>
                </div>
              </li>
            ))}
          </ul>
          <img src={nextGearCarIcon} alt="NextGear Icon" className="ng-why-use__icon" />
        </div>
      </div>
    </section>
  );
}

export default NextGearWhyUse;
